export default __webpack_public_path__ + "515fb1a7861e10e12a416fc6d3ae882a.png";